import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // Yeh .js aur .jsx dono ko utha lega

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);